import { faChevronDown } from '@fortawesome/pro-light-svg-icons';
import PropTypes from 'prop-types';

import { Icon } from '../../Icons';

const ToggleButton = ({
  disabled,
  getToggleButtonProps,
  setTouched,
  toggleButtonLabelText,
}) => {
  return (
    <button
      {...getToggleButtonProps({ onClick: () => setTouched(true) })}
      aria-label={toggleButtonLabelText}
      className="absolute top-0 right-0 p-2 border-0"
      disabled={disabled}
      type="button"
    >
      <Icon icon={faChevronDown} />
    </button>
  );
};
ToggleButton.defaultProps = {
  disabled: false,
};

ToggleButton.propTypes = {
  disabled: PropTypes.bool,
  getToggleButtonProps: PropTypes.func.isRequired,
  setTouched: PropTypes.func.isRequired,
  toggleButtonLabelText: PropTypes.string.isRequired,
};
export default ToggleButton;
